import React from 'react';

type Props = {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const Funnel = ({
  width, height, fill, className,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.88889 21.3333H23.1111V17.7777H8.88889V21.3333ZM0 0V3.55556H32V0H0ZM5.33333 12.4444H26.6667V8.88893H5.33333V12.4444Z"
      fill={fill}
      className="icon-fill"
    />
  </svg>

);

Funnel.defaultProps = {
  width: 16,
  height: 16,
  fill: 'var(--labelColor)',
};

export default Funnel;
